import React, { useEffect, useState } from "react";
import axios from "axios";
import { Navigate } from "react-router-dom";

axios.defaults.withCredentials = true;

export default function ProtectedRoute({ children }) {
  const [loading, setLoading] = useState(true);
  const [authed, setAuthed] = useState(false);

  useEffect(() => {
    axios
      .get("/api/user-info/")
      .then(() => {
        setAuthed(true);
        setLoading(false);
      })
      .catch(() => {
        setAuthed(false);
        setLoading(false);
      });
  }, []);

  if (loading) return null; // or a spinner if you want

  if (!authed) return <Navigate to="/" replace />;

  return children;
}
